(function () {
  /* -------------------------------------------------------------------
     Galerie photo (12/09)

     sections/main-product.liquid rend les miniatures avec data-thumb et
     data-full, mais AUCUN script ne les écoutait : cliquer sur une photo ne
     faisait rien. On câble ici le clic (+ clavier) sur #ProductMainImage.

     Mobile : la colonne passe sur une seule colonne, la bande de miniatures
     se retrouve SOUS une grande image qui occupe presque toute la hauteur
     de l'écran. En tapant une miniature, la photo changeait hors champ — de
     l'écran du client, il ne se passait rien. On ramène donc le cadre dans
     la vue quand il n'y est pas entièrement (ensureVisible), et on recale la
     bande de miniatures sur celle qui vient d'être choisie.

     La fonction de synchronisation est exposée sur le root
     (root.__umGallerySync) pour que le changement de variante, qui remplace
     aussi l'image principale, remette la bonne miniature en surbrillance.
  ------------------------------------------------------------------- */

  /* Recalage direct, sans animation, et c'est volontaire : le défilement
     animé natif (window.scrollTo behavior:'smooth', que base.css active
     aussi via scroll-behavior sur <html>) est annulé sur ces pages —
     vérifié en direct le 12/09, le défilement ne partait tout simplement
     pas. behavior:'instant' court-circuite le scroll-behavior CSS et
     fonctionne dans tous les cas. */
  function scrollPageTo(top) {
    if (top < 0) top = 0;
    try {
      window.scrollTo({ top: top, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(0, top);
    }
  }

  function initGallery(root) {
    var main = root.querySelector('#ProductMainImage');
    var strip = root.querySelector('.product__thumbs');
    if (!main || !strip) return;

    var thumbs = Array.prototype.slice.call(strip.querySelectorAll('[data-thumb]'));
    if (!thumbs.length) return;

    /* Le header fait 68 px sur grand écran mais se replie sur plusieurs
       lignes en mobile, où il peut dépasser 250 px. On ne compte sa hauteur
       que s'il est réellement épinglé en haut de l'écran, et on plafonne à
       un quart de la hauteur visible : sinon le défilement envoie la photo
       tout en bas de l'écran pour rien. */
    function headerOffset() {
      var header = document.querySelector('.site-header');
      var offset = 12;
      if (header) {
        var hr = header.getBoundingClientRect();
        if (hr.top > -2 && hr.top < 2) offset = hr.height + 12;
      }
      var max = window.innerHeight * 0.25;
      return offset > max ? max : offset;
    }

    /* Le cadre photo doit être visible après un clic sur une miniature — et
       on défile du strict minimum nécessaire. */
    function ensureVisible() {
      var rect = main.getBoundingClientRect();
      var offset = headerOffset();
      var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (rect.top < offset - 1) {
        /* Le cadre déborde par le haut : on le recale sous le header. */
        scrollPageTo(pageY + rect.top - offset);
      } else if (rect.bottom > window.innerHeight + 1) {
        /* Il déborde par le bas : on remonte juste ce qu'il faut, sans
           jamais faire passer son haut sous le header. */
        var shift = rect.bottom - window.innerHeight + 12;
        var maxShift = rect.top - offset;
        if (shift > maxShift) shift = maxShift;
        if (shift > 0) scrollPageTo(pageY + shift);
      }
    }

    /* Recale UNIQUEMENT la bande horizontale (jamais la page). */
    function revealThumb(thumb) {
      var left = thumb.offsetLeft;
      var right = left + thumb.offsetWidth;
      if (left < strip.scrollLeft) {
        strip.scrollLeft = left - 10;
      } else if (right > strip.scrollLeft + strip.clientWidth) {
        strip.scrollLeft = right - strip.clientWidth + 10;
      }
    }

    function setActive(active) {
      thumbs.forEach(function (t) {
        var on = t === active;
        if (on) {
          t.classList.add('is-active');
        } else {
          t.classList.remove('is-active');
        }
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function sync() {
      var current = main.getAttribute('src');
      var match = null;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('data-full') === current) {
          match = thumbs[i];
          break;
        }
      }
      setActive(match);
      if (match) revealThumb(match);
    }

    function show(thumb, scroll) {
      var full = thumb.getAttribute('data-full');
      if (!full) return;
      main.setAttribute('src', full);
      if (thumb.getAttribute('alt')) main.setAttribute('alt', thumb.getAttribute('alt'));
      setActive(thumb);
      revealThumb(thumb);
      if (scroll) ensureVisible();
    }

    thumbs.forEach(function (thumb, index) {
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      if (!thumb.getAttribute('title')) {
        thumb.setAttribute('title', 'Voir la photo ' + (index + 1));
      }

      thumb.addEventListener('click', function () {
        show(thumb, true);
      });

      /* Préchargement au survol : la grande image est déjà en cache au clic. */
      thumb.addEventListener('mouseenter', function () {
        if (thumb.getAttribute('data-preloaded')) return;
        thumb.setAttribute('data-preloaded', '1');
        var pre = new Image();
        pre.src = thumb.getAttribute('data-full');
      });

      thumb.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
          event.preventDefault();
          show(thumb, true);
        } else if (key === 'ArrowRight' && thumbs[index + 1]) {
          event.preventDefault();
          thumbs[index + 1].focus();
          show(thumbs[index + 1], false);
        } else if (key === 'ArrowLeft' && thumbs[index - 1]) {
          event.preventDefault();
          thumbs[index - 1].focus();
          show(thumbs[index - 1], false);
        }
      });
    });

    root.__umGallerySync = sync;
    sync();
  }

  function init(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    var dataEl = root.querySelector('[data-variant-data]');
    if (!form || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var idInput = form.querySelector('[data-variant-id]');
    var selects = Array.prototype.slice.call(form.querySelectorAll('select[data-option-index]'));
    var button = form.querySelector('button[type="submit"]');
    var priceWrapper = root.querySelector('[data-price-wrapper]');
    var mainImage = root.querySelector('#ProductMainImage');

    if (!selects.length) return;

    var labels = {
      add: button ? button.getAttribute('data-add-label') : '',
      soldOut: button ? button.getAttribute('data-sold-out-label') : '',
      unavailable: button ? button.getAttribute('data-unavailable-label') : ''
    };

    function chosenOptions() {
      var values = [];
      selects.forEach(function (select) {
        values[parseInt(select.getAttribute('data-option-index'), 10)] = select.value;
      });
      return values;
    }

    function findVariant() {
      var chosen = chosenOptions();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== chosen[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function renderPrice(variant) {
      if (!priceWrapper) return;
      var html = '<span class="price' + (variant.on_sale ? ' price--sale' : '') + '">';
      html += variant.price + ' <span class="price__ttc">TTC</span>';
      if (variant.on_sale && variant.compare_at_price) {
        html += '<s class="price__compare">' + variant.compare_at_price + '</s>';
      }
      html += '</span>';
      priceWrapper.innerHTML = html;
    }

    function syncUrl(variant) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* noop */
      }
    }

    function update() {
      var variant = findVariant();

      if (!variant) {
        if (idInput) idInput.value = '';
        if (button) {
          button.disabled = true;
          button.textContent = labels.unavailable;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? labels.add : labels.soldOut;
      }

      renderPrice(variant);

      if (variant.image && mainImage) {
        mainImage.src = variant.image;
        /* La variante a changé l'image principale : on remet la bonne
           miniature en surbrillance. Pas de défilement ici — le client est
           en train de manipuler le sélecteur, on ne lui bouge pas la page
           sous les doigts. */
        if (root.__umGallerySync) root.__umGallerySync();
      }

      syncUrl(variant);
    }

    selects.forEach(function (select) {
      select.addEventListener('change', update);
    });

    update();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-product-root]');
    Array.prototype.forEach.call(roots, function (root) {
      initGallery(root);
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
